class SubscriptionProductFunnelAdapter {
  static _NOOP_TTQ = { track() {} };
  static _patched = false;

  static ensureSpecialCrateGlobal() {
    const g = typeof globalThis !== 'undefined' ? globalThis : window;
    if (g.specialCrate === undefined) {
      g.specialCrate = null;
    }
  }

  constructor() {
    SubscriptionProductFunnelAdapter.ensureSpecialCrateGlobal();

    const gv = window.globalVariables;
    this._root = document.querySelector('[data-subscription-product-single]');
    this._active =
      (!!gv && gv.templateSuffix === 'subscription-product') || !!this._root;
    this._debug = !!window.SUBSCRIPTION_PRODUCT_DEBUG;
    this._proto =
      typeof subscriptionFunnalCommon !== 'undefined' ? subscriptionFunnalCommon.prototype : null;
    this._orig = Object.create(null);
    this._restoreCtaLabels = this.restoreProductCtaLabels.bind(this);

    if (!this._proto) {
      this._active = false;
    }
  }

  install() {
    if (!this._active || SubscriptionProductFunnelAdapter._patched) {
      return;
    }

    this._patchCheckSelectedOptions();
    this._patchSetVariantDetails();
    this._patchSelectCrate();
    this._patchAddToCart();
    window.restoreSubscriptionProductCtaLabels = this._restoreCtaLabels;
    SubscriptionProductFunnelAdapter._patched = true;
  }

  _warn() {
    if (this._debug && typeof console !== 'undefined' && console.warn) {
      console.warn('[subscription-product]', ...arguments);
    }
  }

  _querySubmitButtons() {
    if (this._root) {
      return this._root.querySelectorAll('[data-submit-subscription]');
    }
    return document.querySelectorAll('[data-submit-subscription]');
  }

  restoreProductCtaLabels() {
    const root = document.querySelector('[data-subscription-product-single]');
    if (!root) {
      return;
    }
    const buttons = root.querySelectorAll('[data-submit-subscription]');
    for (let i = 0; i < buttons.length; i++) {
      const btn = buttons[i];
      if (btn.classList.contains('soldout')) {
        continue;
      }
      const span = btn.querySelector('.add-text[data-default-cta]');
      if (!span) {
        continue;
      }
      const def = span.getAttribute('data-default-cta');
      if (!def || span.textContent.trim() === 'Sold Out') {
        continue;
      }
      span.textContent = def;
    }
  }

  _setSubmitButtonsSoldOut() {
    const nodes = this._querySubmitButtons();
    for (let i = 0; i < nodes.length; i++) {
      const btn = nodes[i];
      btn.classList.add('disabled');
      const addText = btn.querySelector('.add-text');
      if (addText) {
        addText.innerText = 'Sold Out';
      }
    }
    window.subscriptionFlow.isProductFound = false;
  }

  _setSubmitButtonsInStock() {
    const nodes = this._querySubmitButtons();
    for (let i = 0; i < nodes.length; i++) {
      const btn = nodes[i];
      btn.classList.remove('disabled');
      const addText = btn.querySelector('.add-text');
      if (addText) {
        addText.innerText = 'Bring It Home';
      }
    }
    window.subscriptionFlow.isProductFound = true;
    this.restoreProductCtaLabels();
  }

  static _parseMainProductVariantJson(variantEl, onError) {
    const raw = (variantEl.textContent || variantEl.innerText || '').trim();
    if (!raw) {
      return { error: 'empty' };
    }
    let parsed;
    try {
      parsed = JSON.parse(raw);
    } catch (e) {
      if (onError) {
        onError(e);
      }
      return { error: 'parse' };
    }
    if (!Array.isArray(parsed)) {
      if (onError) {
        onError(new Error('not-array'));
      }
      return { error: 'not-array' };
    }
    return { data: parsed };
  }

  static _findVariantRow(rows, size) {
    for (let i = 0; i < rows.length; i++) {
      const row = rows[i];
      if (row && row.variant_title === size) {
        return row;
      }
    }
    return null;
  }

  static _isValidSellingPlanRow(row) {
    if (!row || typeof row !== 'object') {
      return false;
    }
    const vid = parseInt(row.variant_id, 10);
    const spid = parseInt(row.selling_plan_id, 10);
    return Number.isFinite(vid) && vid > 0 && Number.isFinite(spid) && spid > 0;
  }

  _patchCheckSelectedOptions() {
    if (typeof this._proto.checkSelectedOptions !== 'function') {
      return;
    }

    const self = this;
    this._orig.checkSelectedOptions = this._proto.checkSelectedOptions;
    this._proto.checkSelectedOptions = function () {
      if (self._active) {
        return;
      }
      return self._orig.checkSelectedOptions.call(this);
    };
  }

  _patchSetVariantDetails() {
    if (typeof this._proto.setVariantDetails !== 'function') {
      return;
    }

    const self = this;
    this._orig.setVariantDetails = this._proto.setVariantDetails;
    this._proto.setVariantDetails = function (ele) {
      const variantEl = ele && ele.querySelector('[data-main-product-variant]');
      if (!variantEl) {
        return;
      }
      const parsed = SubscriptionProductFunnelAdapter._parseMainProductVariantJson(variantEl, (e) =>
        self._warn('variant JSON', e)
      );
      if (parsed.error) {
        self._setSubmitButtonsSoldOut();
        return;
      }
      const size = window.subscriptionFlow.productSize;
      const row = SubscriptionProductFunnelAdapter._findVariantRow(parsed.data, size);
      if (!row || !SubscriptionProductFunnelAdapter._isValidSellingPlanRow(row)) {
        self._warn('no valid variant row for size', size);
        self._setSubmitButtonsSoldOut();
        return;
      }
      const flow = window.subscriptionFlow;
      flow.variantId = parseInt(row.variant_id, 10);
      flow.selling_plan_id = parseInt(row.selling_plan_id, 10);
      flow.discount_amount = row.discount_amount;
      flow.discount_code = row.discount_code;
      flow.start_date = row.start_date;
      flow.end_date = row.end_date;
      flow.per_crate_price = row.per_crate_price;
      flow.discount_type = row.discount_Type;
      self._setSubmitButtonsInStock();
    };
  }

  _patchSelectCrate() {
    if (typeof this._proto._selectCrate !== 'function') {
      return;
    }

    const self = this;
    this._orig.selectCrate = this._proto._selectCrate;
    this._proto._selectCrate = function (ele) {
      self._orig.selectCrate.call(this, ele);
      self.restoreProductCtaLabels();
    };
  }

  _patchAddToCart() {
    if (typeof this._proto._AddToCart !== 'function') {
      return;
    }

    const self = this;
    this._orig.addToCart = this._proto._AddToCart;
    this._proto._AddToCart = async function (event) {
      if (!self._active) {
        return self._orig.addToCart.call(this, event);
      }
      const prevTtq = window.ttq;
      const shim =
        typeof prevTtq === 'undefined' || typeof prevTtq.track !== 'function';
      if (shim) {
        window.ttq = SubscriptionProductFunnelAdapter._NOOP_TTQ;
      }
      try {
        return await self._orig.addToCart.call(this, event);
      } finally {
        if (shim) {
          window.ttq = prevTtq;
        }
      }
    };
  }
}

class SubscriptionProductFunnelAdapterBootstrap {
  static init() {
    const adapter = new SubscriptionProductFunnelAdapter();
    adapter.install();
  }
}

SubscriptionProductFunnelAdapterBootstrap.init();
